function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dealtScheduleCountApi, scheduleTypesCreateApi, scheduleTypesEditApi, scheduleTypesDeleteApi, scheduleTypesApi } from '@/api/user';
export default {
  name: 'CalendarBar',
  components: {},
  data: function data() {
    return {
      value: new Date(),
      calendar: [],
      dateShow: false,
      dailyDay: {
        startTime: '',
        endTime: ''
      },
      tableData: [],
      checkedTypes: [],
      isShow: true,
      data: {
        time: this.$moment(new Date()).format('YYYY-MM-DD'),
        type: []
      }
    };
  },
  mounted: function mounted() {
    this.nextTPrevClick();
    this.getTypes();
  },
  methods: {
    dateBnt: function dateBnt(data) {
      this.dateShow = true;
      this.data.time = data;
      this.handleEmit();
    },
    handleEmit: function handleEmit() {
      if (this.dateShow) {
        this.$emit('handleDate', this.data, 1);
      } else {
        this.$emit('handleDate', this.data);
      }
    },
    // 列表
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                cid: _this.checkedTypes,
                start_time: _this.dailyDay.startTime,
                end_time: _this.dailyDay.endTime,
                period: 3
              };
              _context.next = 3;
              return dealtScheduleCountApi(data);
            case 3:
              result = _context.sent;
              _this.calendar = result.data;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleCheckedKey: function handleCheckedKey(value) {
      this.data.type = this.checkedTypes;
      this.handleEmit();
    },
    getTypes: function getTypes() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return scheduleTypesApi();
            case 2:
              result = _context2.sent;
              _this2.tableData = result.data;
              _this2.tableData.map(function (value) {
                _this2.checkedTypes.push(value.id);
              });
              _this2.data.type = _this2.checkedTypes;
              _context2.next = 8;
              return _this2.handleEmit();
            case 8:
              _context2.next = 10;
              return _this2.setCalendarButton();
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 新增
    handleShow: function handleShow() {
      var _this3 = this;
      this.$modalForm(scheduleTypesCreateApi({})).then(function (res) {
        _this3.getTypes(1);
      });
    },
    // 编辑
    handleEdit: function handleEdit(val) {
      var _this4 = this;
      this.$modalForm(scheduleTypesEditApi(val.id)).then(function (res) {
        _this4.getTypes();
      });
    },
    // 删除
    handleDelete: function handleDelete(val) {
      var _this5 = this;
      this.$modalSure('您确定要删除这条日程类型吗').then(function () {
        scheduleTypesDeleteApi(val.id).then(function (res) {
          _this5.getTypes();
        });
      });
    },
    setCalendarButton: function setCalendarButton() {
      var _this6 = this;
      this.$nextTick(function () {
        var prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)');
        var nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');
        _this6.dailyDay.startTime = document.querySelector('.dealt-date .el-calendar-table__row:first-child td:nth-child(1) input').value;
        _this6.dailyDay.endTime = document.querySelector('.dealt-date .el-calendar-table__row:last-child td:last-child input').value;
        _this6.getList();
        prevBtn.setAttribute('class', 'el-button--text');
        prevBtn.lastChild.setAttribute('class', 'el-icon-arrow-left');
        prevBtn.lastChild.innerHTML = '';
        nextBtn.setAttribute('class', 'el-button--text');
        nextBtn.lastChild.setAttribute('class', 'el-icon-arrow-right');
        nextBtn.lastChild.innerHTML = '';
      });
    },
    nextTPrevClick: function nextTPrevClick() {
      var prevBtn = document.querySelector('.dealt-date .el-calendar__button-group .el-button-group>button:nth-child(1)');
      var nextBtn = document.querySelector('.dealt-date .el-calendar__button-group .el-button-group>button:nth-child(3)');
      var prevFirst = document.querySelector('.dealt-date .el-calendar-table__row:first-child');
      var nextLast = document.querySelector('.dealt-date .el-calendar-table__row:last-child');
      var prevArr = prevFirst.getElementsByClassName('prev');
      var nextArr = nextLast.getElementsByClassName('next');
      for (var i = 0; i < prevArr.length; i++) {
        this.tabClick(prevArr[i]);
      }
      for (var _i = 0; _i < nextArr.length; _i++) {
        this.tabClick(nextArr[_i]);
      }
      this.tabClick(prevBtn);
      this.tabClick(nextBtn);
    },
    tabClick: function tabClick(obj) {
      var _this7 = this;
      obj.addEventListener('click', function (e) {
        _this7.dailyDay.startTime = document.querySelector('.dealt-date .el-calendar-table__row:first-child td:nth-child(1) input').value;
        _this7.dailyDay.endTime = document.querySelector('.dealt-date .el-calendar-table__row:last-child td:last-child input').value;
        _this7.getList();
      });
    },
    // 判断是否是休息日
    getRest: function getRest(day) {
      var len = this.calendar.length;
      var show = true;
      if (len > 0) {
        for (var i = 0; i < len; i++) {
          if (this.calendar[i].time === day) {
            if (this.calendar[i].is_rest == 1) {
              show = true;
            } else if (this.calendar[i].is_rest == 0) {
              show = false;
            }
            break;
          }
        }
      }
      return show;
    },
    // 判断是否显示完成图标
    getCalendarDay: function getCalendarDay(day) {
      var len = this.calendar.length;
      var str = '';
      if (len > 0) {
        for (var i = 0; i < len; i++) {
          if (this.calendar[i].time === day) {
            if (this.calendar[i].no_submit == 0) {
              str = '<i class="iconfont iconyiguo color-default"></i>';
            } else if (this.calendar[i].no_submit > 0) {
              str = '<i class="iconfont iconyiguo color-danger"></i>';
            }
            break;
          }
        }
      }
      return str;
    }
  }
};